import type React from 'react';

import { useField } from 'react-final-form';

import { ImageUploaderSunriseV2 } from '#src/app/shared/components/imageUpload';

import { ImagePreview } from './components/ImagePreview';
import { useImageUploaderUppyWrapper } from './hooks/useImageUploaderUppyWrapper';

export const ImageUploaderUppyWrapper: React.FC<{
	fieldName: string;
	onChange: (value: string) => void;
}> = ({ fieldName, onChange }) => {
	const {
		data: { isLoading, uppy },
		actions: { removeImage },
	} = useImageUploaderUppyWrapper({ onChange });
	const { input: mediaInputField } = useField<string>(fieldName);

	return (
		<div>
			{mediaInputField.value ? (
				<ImagePreview image={mediaInputField.value} removeImage={removeImage} />
			) : (
				<ImageUploaderSunriseV2 uppy={uppy} fileInputId={fieldName} disabled={isLoading} />
			)}
		</div>
	);
};
